module.exports = __webpack_public_path__ + "img/font-italic.8fb2a2bf.svg";